<template>
  <Screen>
    <div class="map-content">
      <div class="map-road"></div>
      <Route class="map-route" ref="route" @finish="carFinished"></Route>
      <City :back="$store.state.showCityBack" class="map-city"></City>
    </div>
  </Screen>
</template>

<script>
import City from '@/components/City/City.vue'
import Route from '@/components/Map/Route.vue'
import Screen from '@/components/Screen.vue'

export default {
  components: {
    Route,
    Screen,
    City
  },
  methods: {
    carFinished () {
      this.busy = false
    },
    next () {
      this.step = typeof this.step !== 'number' ? 0 : this.step + 1
    }
  }
}
</script>

<style lang="scss">
  .map-content {
    position: relative;
  }

  .map-route {
    position: relative;
    display: block;
    left: 50%;

    @include mq(desktop) {
      width: $map-width-desktop;
      margin-left: calc(#{$map-width-desktop}/-2);
    }
    @include mq(scale) {
      width: 100%;
      transform: translateX(-50%);
    }
    @include less(tablet) {
      max-width: $map-width-mobile;
      margin-left: calc(#{$map-width-mobile}/-2);
    }
  }

  .map-city {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
  }

  .map-road {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-position: 50% 0%;
    background-repeat: no-repeat;

    @include more(scale) {
      background-image: url(/map/roads.png);
    }
    @include mq(scale) {
      background-size: 100%;
    }
    @include less(tablet) {
      background-image: url(/map/roads_mobile.png);
    }
  }
</style>
